export default "__VITE_ASSET__a387466b__"